import { VfSwiper } from '@vfit/shared/atoms';
import { getDayAndMonth, getWeekday } from '@vfit/shared/hooks';
import { forwardRef, useMemo } from 'react';
import { FrameDateInput } from '../FrameDateInput';
import { useSlotsCalendarInput } from './slotsCalendarInput.hook';
import { ISlotsCalendarInput } from './slotsCalendarInput.models';
import * as S from './slotsCalendarInput.style';

export const SlotsCalendarInput = forwardRef<HTMLInputElement, ISlotsCalendarInput>(
  ({ children, dateTimes = [], onChange, slotsGroupsMaxHeight, styled, ...rest }, ref) => {
    const { isMobile, isTablet, frameDateInputsName, onSelect, refCallback, slots } =
      useSlotsCalendarInput({
        dateTimes,
        onChange,
        ref,
      });

    const slotsGroups = useMemo(
      () =>
        slots.map((group) => (
          <div key={group[0]}>
            <S.Day>
              {getWeekday(group[0])}
              {isMobile ? ' ' : <br />}
              <strong>{getDayAndMonth(group[0])}</strong>
            </S.Day>
            <S.Slots className="slots" slotsGroupsMaxHeight={slotsGroupsMaxHeight}>
              {group[1].map(({ id, validFor: { endDateTime, startDateTime } }) => (
                <FrameDateInput
                  endDateTime={endDateTime}
                  key={id}
                  name={frameDateInputsName}
                  onChange={onSelect}
                  startDateTime={startDateTime}
                  value={id}
                  variant="short"
                />
              ))}
            </S.Slots>
          </div>
        )),
      [frameDateInputsName, isMobile, onSelect, slots, slotsGroupsMaxHeight]
    );

    return (
      <S.Wrapper styled={styled}>
        <input {...rest} hidden onChange={onChange} tabIndex={-1} type="text" ref={refCallback} />
        {isMobile ? (
          <>
            <S.SlotsGroups>{slotsGroups}</S.SlotsGroups>
            {children}
          </>
        ) : (
          <VfSwiper
            centeredSlides={false}
            navigation
            noSwipingSelector="label"
            pagination={false}
            slidesPerView={isTablet ? 2 : 3}
            slideWidth={180}
            spaceBetween={24}
            freeMode={undefined}
            effect={undefined}
          >
            {slotsGroups}
            {children && <S.Group slotsGroupsMaxHeight={slotsGroupsMaxHeight}>{children}</S.Group>}
          </VfSwiper>
        )}
      </S.Wrapper>
    );
  }
);

